import { Icon, type KitIconName } from '@eleo-rh/core-ui'
import { useI18n } from 'context/I18nProvider'
import { isRouteErrorResponse, useRouteError } from 'react-router-dom'

interface ErrorType {
  message?: string
  statusText?: string
}

interface BaseProps {
  title?: string
  className?: string
  iconName?: KitIconName
  customContent?: string
}

interface ErrorContentProps {
  error: ErrorType | any
}

interface ErrorPageProps {
  customError: object
}

export function ErrorContent({ error, title, iconName, customContent }: BaseProps & ErrorContentProps) {
  const { i18n } = useI18n()

  let customErrorMessage = ''

  if (error?.response?.status === 403) {
    customErrorMessage = i18n('page-403.text')
  }

  return (
    <div id="error-page" className="flex flex-col gap-4 w-max mx-auto">
      <div className="flex items-center gap-2">
        <Icon name={iconName || 'triangle-exclamation'} size={32} color="var(--color-warning-500" />
        <h2 className="text-3xl font-bold my-0">{title || i18n('global.error_message')}</h2>
      </div>
      <div>
        <i>{customErrorMessage || i18n(error.statusText) || error.message}</i>
      </div>
      {customContent}
    </div>
  )
}

export default function ErrorPage({ customError, iconName, customContent, title }: BaseProps & ErrorPageProps) {
  const routeError: ErrorType | unknown = useRouteError()
  const { i18n } = useI18n()

  let error = routeError || customError
  let customTitle = title

  if (isRouteErrorResponse(error)) {
    if (error.status === 404) {
      iconName = 'magnifying-glass'
      error = { statusText: i18n('page-not-found.text') }
      customTitle = '404'
    }
  }

  return (
    <main>
      <ErrorContent error={error} title={customTitle} iconName={iconName} customContent={customContent} />
    </main>
  )
}
